export const UPDATE_OPTIONS_LIST = 'TradeIn::updateOptionsList';
export const UPDATE_MAX_PRICE = 'TradeIn::updateMaxPrice';
export const SET_ACTIVE_OPTION = 'TradeIn::setActiveOption';
export const SET_WAIT_STATUS = 'TradeIn::setWaitStatus';
export const SET_ERROR_STATUS = 'TradeIn::setErrorStatus';
